import { videos } from "@/mocks/videoData";

interface VideoCardProps {
  id: number;
  title: string;
  thumbnail: string;
  duration: string;
  source: string;
  views: string;
  rating: number;
}

export default function VideoCard({ id, title, thumbnail, duration, source, views, rating }: VideoCardProps) {
  return (
    <article className="group cursor-pointer rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300">
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          title={`${title} - 在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
          <i className="ri-play-circle-fill text-white text-4xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
        </div>
        <span className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
          {duration}
        </span>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-2">
            <span className="bg-secondary-100 text-secondary-900 px-1.5 py-0.5 rounded text-xs whitespace-nowrap">{source}</span>
            <span className="whitespace-nowrap">{views}次播放</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-yellow-500 text-xs"></i>
            <span className="font-medium text-foreground-700">{rating}</span>
          </div>
        </div>
      </div>
    </article>
  );
}